<!-- Incorrect Role -->
<div *ngIf="!oktaService.admin" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    It looks like you've arrived at the wrong page for your role.
    <button hc-button size="lg" routerLink="/">Return to Home Page</button>
</div>

<div *ngIf="oktaService.admin" class="pd-content-container admin-content-container">
    <hc-sidenav [tabs]="tabs" [showFavorites]="false">
    </hc-sidenav>
    <div class="pd-admin-portal-tab-content">
        <router-outlet></router-outlet>
    </div>
</div>